import { watch } from 'vue';
import { useMeStore } from '@/stores/me';
import echo from '@/plugins/echo';

/**
 * Plugin de Pinia: real-time sync via Soketi/Echo.
 * Stores con `modelName` se refrescan automáticamente.
 *
 * El canal es el de la EMPRESA, no el del usuario. Antes se escuchaba
 * `refresh.{user_id}`, así que sólo llegaban los cambios propios: si otro
 * vendedor cargaba una venta, esta pantalla no se enteraba. Ahora llega
 * cualquier cambio de la empresa, venga de una pantalla, de la API de
 * facturación o de un webhook.
 */

if (!window._rtSync) window._rtSync = { stores: {} };
const reg = window._rtSync;

function ensureListener(companyId) {
  if (reg.bound) return;
  reg.bound = true;

  const channelName = `refresh.company.${companyId}`;
  echo.leave(channelName);

  setTimeout(() => {
    echo.channel(channelName).listen('.model.changed', payload => {
      const s = reg.stores[payload.model];
      if (s) {
        console.log(`[sync] ${payload.model} ${payload.action}`);
        s.onModelChanged?.(payload);
      }
    });

    console.log(
      `[sync] Ready on ${channelName}:`,
      Object.keys(reg.stores).join(', ')
    );
  }, 300);
}

export function realtimeSyncPlugin({ store, options }) {
  const m = options.modelName;
  if (!m) return;

  reg.stores[m] = store;
  store.modelName = m;

  const meStore = useMeStore();
  const companyId = meStore.getUser?.company_id;

  if (companyId) {
    ensureListener(companyId);
  } else if (!reg.watching) {
    reg.watching = true;
    const stop = watch(
      () => meStore.getUser,
      u => {
        if (u?.company_id) {
          ensureListener(u.company_id);
          stop();
        }
      }
    );
  }
}
